import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import Utils from 'src/app/utils';

import moment from 'moment';
import * as _ from 'lodash-es';
declare var require: any;

@Component({
  selector: 'app-workers-massdelete',
  templateUrl: './workers-massdelete.component.html',
  styleUrls: ['./workers-massdelete.component.scss']
})
export class WorkersMassdeleteComponent implements OnInit {
  u = Utils;

  workers : any;
  ids : any = [];
  filter: any;
  selected: any;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() }

  }

  getWorkers(){
    let filter = {
      created_start: this.selected.startDate.format("YYYY-MM-DD"),
      created_end: this.selected.endDate.format("YYYY-MM-DD"),
      pagesize:1000
    }


    this.okService.get("workers",filter)
    .subscribe((data) => {

      //console.log(data.body);

      this.workers = data.body;

      let self = this;
    
      _.forEach(this.workers, function(w:any) {
        self.ids.push(w['id']);
      });

      //console.log(this.ids);



    });


  }
  updateFilter(){
    this.getWorkers();
  }

  toggleDelete(id:any){
    if(this.ids.includes(id)){
      _.remove(this.ids, function(n:any) {
        return n == id;
      });
    } else {
      this.ids.push(id);
    }
  }

  deleteWorkers(){

    if(confirm(this.transloco.translate("Are you sure you want to delete "))) {

    if(this.ids.length > 0){

      this.okService.post("workers/massdelete",{ids:this.ids})
      .subscribe((data) => {
  
        //console.log(data);

        this.workers = null;
        this.ids = [];
  
        this.okService.setAlert(this.transloco.translate("The workers have been deleted"),"success");
  
      });

    }

  }

  }


}
